import classNames from "classnames";
import React, {FC, memo} from "react";
import css from "./SummarySection.less";

type SummarySectionProps = {
    title?: string | React.ReactNode;
    extra?: string | React.ReactNode;
    underLine?: boolean;
    content?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
};

const SummarySection: FC<SummarySectionProps> = ({title, extra, underLine = true, content, style, className}) => {
    const actualStyle = {...style};

    return (
        <div className={classNames(css.root, className)} style={actualStyle}>
            {title ? (
                <div className={underLine ? classNames(css.header, css.underLine) : classNames(css.header)}>
                    <div>{title}</div>
                    <div>{extra}</div>
                </div>
            ) : null}
            <div className={css.content}>{content}</div>
        </div>
    );
};

export default memo(SummarySection);
